<nz-spin [nzSpinning]="isLoading">
    <div class="container">
        <div class="page-header">
            <div>
                <p class="eyebrow">Dispositions</p>
                <h2>Disposition Admin</h2>
                <p class="subtitle">Modify Current Dispositions</p>
            </div>
            <div class="header-actions">
                <button nz-button nzShape="round" nzType="primary" (click)="createDisposition()" [disabled]="isLoading">
                    <i nz-icon nzType="plus-circle"></i>
                    Create New Disposition
                </button>
                <button nz-button nzShape="round" nzType="default" (click)="getData()" [disabled]="isLoading">
                    <i nz-icon nzType="reload"></i>
                    Refresh
                </button>
            </div>
        </div>
        <div class="filter-card">
            <div class="filter-group">
                <label>Provider</label>
                <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select a Provider" [(ngModel)]="selectedProvider"
                    (ngModelChange)="getData()">
                    <nz-option *ngFor="let p of availableProvidersByDist" [nzValue]="p.id" [nzLabel]="p.name"></nz-option>
                </nz-select>
            </div>
                <div class="header-actions">
                </div>
                    <nz-modal [(nzVisible)]="createDispoModal" nzTitle="Create Disposition" (nzOnCancel)="createDispositionCancel()" (nzOnOk)="createDispositionSave()">
                        <ng-container *nzModalContent>
                            <nz-spin [nzSpinning]="isLoading">
                            <form nz-form [formGroup]="createDispo">
                                <div class="marginT">
                                    <nz-form-item>
                                    <nz-form-label nzRequired for="dispName">Disposition Name</nz-form-label><br>
                                    <nz-form-control nzErrorTip="Please input Disposition Name">
                                        <input nz-input id="dispName" formControlName="dispName" />
                                    </nz-form-control>
                                    </nz-form-item>
                                </div>
                                <div class="marginT">
                                    <nz-form-item>
                                        <nz-form-label nzRequired for="pin_color">Pin Color</nz-form-label>
                                        <nz-form-control nzErrorTip="Please select Pin Color">
                                            <nz-color-picker nzShowText formControlName="pin_color" />
                                        </nz-form-control>
                                    </nz-form-item>
                                </div>
                                <div class="marginT">
                                    <nz-form-item>
                                        <nz-form-label nzRequired for="provider_id">Provider ID</nz-form-label><br>
                                        <nz-form-control nzErrorTip="Please select Provider ID">
                                            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select a Provider" formControlName="provider_id">
                                                <nz-option *ngFor="let p of availableProvidersByDist" [nzValue]="p.id" [nzLabel]="p.name"></nz-option>
                                            </nz-select>
                                        </nz-form-control>
                                    </nz-form-item>
                                </div>
                                <div class="marginT">
                                    <nz-form-item>
                                        <nz-form-label for="abbreviation">Abbreviation</nz-form-label><br>
                                        <nz-form-control>
                                            <input nz-input placeholder="Max 2 Characters" maxLength="2" [style.width.%]="40" id="abbreviation" formControlName="abbreviation" />
                                        </nz-form-control>
                                    </nz-form-item>
                                </div>
                                <div class="marginT"> 
                                    <nz-form_item>
                                        <nz-form-label for="text_color">Abbreviation Text Color</nz-form-label>
                                        <nz-color-picker nzShowText formControlName="text_color" />
                                    </nz-form_item>
                                </div>
                            </form>
                            </nz-spin>
                        </ng-container>
                    </nz-modal>
            <div class="filter-actions">
            </div>
        </div>
        <nz-table #basicTable [nzData]="dispositions" [nzFrontPagination]="false" [nzTotal]="total" nzBordered
            [nzPageSize]="pageSize" [nzPageIndex]="pageIndex">
            <thead>
                <tr>
                    <th nzWidth="60%">Disposition Name</th>
                    <th nzWidth="10%">Status</th>
                    <th nzWidth="12%">Pin Color</th>
                    <th nzWidth="5%">Abbreviation</th>
                    <th nzWidth="12%">Text Color</th>
                    <th nzWidth="5%"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let disp of dispositions">
                    <td>{{ disp.disposition }}</td>
                    <td>
                        <nz-tag [nzColor]="disp.state_name === true ? 'green' : 'gray'">
                            {{ disp.state_name === true ? 'Enabled' : 'Disabled' }}
                        </nz-tag>
                    </td>
                    <div class="color-block">
                        <nz-color-block [nzColor]="disp.pin" nzSize="large"></nz-color-block>
                    </div>
                    <td>{{ disp.abbreviation }}</td>
                    <div class="color-block">
                        <nz-color-block [nzColor]="disp.text_color" nzSize="large"></nz-color-block>
                    </div>
                    <td>
                        <button nz-button [nzSize]="size" nzType="default" (click)="editDisposition(disp)">Edit</button>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    <nz-modal [(nzVisible)]="editModal" nzTitle="Editing Disposition: {{ currentDisp.value.disposition }}" (nzOnCancel)="editDispositionCancel()" (nzOnOk)="editDispositionSave()">
        <ng-container *nzModalContent>
            <nz-spin [nzSpinning]="isLoading">
                <form [formGroup]="currentDisp">
                    <div class="marginT">
                        <nz-form-item>
                            <nz-form-label for="disposition">Disposition Name</nz-form-label>
                            <nz-form-control nzErrorTip="Must Not be Empty">
                                <input nz-input id="disposition" formControlName="disposition" />
                            </nz-form-control>
                        </nz-form-item>
                    </div> 
                    <div class="marginT">
                        <nz-form-item>
                            <nz-form-label for="pin_color">Pin Color</nz-form-label>
                            <nz-form-control nzErrorTip="Must Not be Empty">
                                <nz-color-picker nzShowText formControlName="pin" />
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="marginT">
                        <nz-form-item>
                            <nz-form-label for="abbreviation">Abbreviation</nz-form-label>
                            <nz-form-control>
                                <input nz-input placeholder="Max 2 Characters" maxlength="2" [style.width.%]="30" id="abbreviation" formControlName="abbreviation" />
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="marginT">
                        <nz-form-item>
                            <nz-form-label for="text_color">Abbreviation Text Color</nz-form-label>
                            <nz-form-control>
                                <nz-color-picker nzShowText formControlName="text_color" />
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div class="marginT">
                        <nz-form-item>
                            <nz-form-label for="state_name">Status</nz-form-label>
                            <nz-form-control>
                            <nz-switch id="state-name" formControlName="state_name"></nz-switch>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </form>
            </nz-spin>
        </ng-container>
    </nz-modal>
    </div>
</nz-spin>
